import api from "../axiosRequest";
export const SignUpApi = async (data) => {
  return api.post("v1/auth/signup", data);
};

export const SignInApi = async (data) => {
  return api.post("v1/auth/admin/signin", data);
};
